import React, { useContext, useEffect, useState } from "react";
import { InputAuto } from "../../../../../controls";
import { AppContext } from "App";

const InputSelectItem = ({ stockDetails, values, setValues, setAlert }) => {
  const { settings } = useContext(AppContext);
  const [items, setItems] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [findErr, setFindErr] = useState("");

  useEffect(() => {
    if (stockDetails && stockDetails.stockProds)
      setItems([
        ...stockDetails.stockProds
          .filter((j) => j.totalReceiveQty > 0)
          .map((i) => ({
            ...i,
            subtitle: `${i.sku} | ${settings?.currSymbol} ${i.unitPrice}`,
          })),
      ]);
    else setItems([]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockDetails]);

  const handleSelect = (e, val) => {
    var existInList = values.stockReturnItems.some(
      (i) => i.prodId === val.prodId && i.varProdId === val.varProdId
    );

    if (!existInList) {
      setValues((j) => ({
        ...j,
        stockReturnItems: [
          {
            key: val.id,
            isVariant: val.isVariant,
            sku: val.sku,
            prodId: val.prodId,
            prod: val.prod,
            varProdId: val.varProdId,
            varProd: val.varProd,
            unitPrice: val.unitPrice || "",
            qty: 1,
            returnReason: 1,

            totalReceiveQty: val.totalReceiveQty || 0,
            label: val.label,
            subtitle: val.subtitle,
          },
          ...j.stockReturnItems,
        ],
      }));
    } else if (existInList) {
      setValues((x) => ({
        ...x,
        stockReturnItems: [
          ...x.stockReturnItems.map((j) =>
            j.prodId === val.prodId && j.varProdId === val.varProdId
              ? { ...j, qty: parseFloat(j.qty) + 1 }
              : j
          ),
        ],
      }));
    }
    setFindErr("");
  };

  const handleSearch = (e, val) => {
    setSearchVal(val);
  };

  return (
    <div aria-hidden={true}>
      <InputAuto
        disabled={!stockDetails.id ? true : false}
        label="Search or Scan Product"
        value={searchVal}
        onChange={handleSelect}
        onInputChange={handleSearch}
        inputValue={searchVal}
        // onKeyDown={(e) => e.which === 13 && handleScan(e, searchVal)}
        classes={{ paper: "shadow-sm" }}
        options={[...items]}
        error={findErr}
      />
      {!stockDetails.id && (
        <span className="pl-2 text-[12px] text-yellow-400">
          Please first validate the ordered stock.
        </span>
      )}
    </div>
  );
};

export default InputSelectItem;
